export default class CreateKeyOtp {
    constructor(public send: boolean) {
    }
}
